module.exports = __webpack_public_path__ + "static/media/flow-dark.8c8371b6.svg";